import { render, staticRenderFns } from "./ItemGroupDisplayView.vue?vue&type=template&id=164629ad"
import script from "./ItemGroupDisplayView.vue?vue&type=script&lang=js"
export * from "./ItemGroupDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports